import React from "react";
import './Landing.css'

export default function Landing () {

    return(
        <div className="containerNeon">
            <a href="#"><span>Ingresar</span></a>
        </div>
    )
    
}